import { Page, Tabs } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-use';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCurrentUser } from 'utils/user';

type SettingsAgentsTab = 'agents' | 'workloads' | 'roles';

export const SettingsAgentsView = (): JSX.Element => {
  const navigate = useAppNavigate();
  const location = useLocation();

  const flags = useFeatureFlag(['custom-roles']);
  const {
    currentRole: { atLeastAdmin },
  } = useCurrentUser();

  const hasRolesView = flags.customRoles && atLeastAdmin;

  const settingsAgentsTabs = useMemo(
    () =>
      [
        { label: 'Agents', id: 'agents' },
        { label: 'Workloads', id: 'workloads' },
        ...(hasRolesView
          ? [{ label: 'Roles', id: 'roles' as SettingsAgentsTab }]
          : []),
      ] satisfies { label: string; id: SettingsAgentsTab }[],
    [hasRolesView],
  );

  const handleTabChange = (value: string) => {
    const tab = value as SettingsAgentsTab;

    if (tab === 'agents') {
      navigate({ path: '/settings/agents' });
    } else {
      navigate({ path: `/settings/agents/${tab}` });
    }

    ampli.settingsAgentsTabClicked({ tab });
  };

  const selectedTab = (location.pathname?.split('/').pop() ??
    'agents') as SettingsAgentsTab;

  return (
    <Page>
      <Page.Head title="Agents" />

      <Page.Tabs>
        <Tabs
          tabs={settingsAgentsTabs}
          selectedId={selectedTab}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
